<template>
  <div class="bank-card">
    <div class="bank-card__cover">
      <img :src="coverImage" :alt="typeLabel" />
    </div>
    <div class="bank-card__body">
      <el-tooltip
        :content="data.questionBankName"
        placement="top"
        :disabled="!data.questionBankName"
      >
        <h3 class="bank-card__title">
          {{ data.questionBankName || "-" }}
        </h3>
      </el-tooltip>
      <p class="bank-card__course">关联课程：{{ courseName || "-" }}</p>
      <div class="bank-card__meta">
        <span>试题 {{ data.questionCount || 0 }} 题</span>
        <span class="bank-card__meta-dot">|</span>
        <span>题型 {{ data.questionTypeCount || 0 }}</span>
      </div>
      <div class="bank-card__time">创建时间：{{ data.createTime || "-" }}</div>
      <div class="bank-card__footer">
        <el-button
          plain
          round
          size="small"
          type="primary"
          @click.stop="openQuestionBank"
          >查看</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="primary"
          @click.stop="addQuestion"
          >新增试题</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="danger"
          @click.stop="deleteInfo"
          >删除</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { deleteQuestionBank } from "@/api/questionBank";

const theoryPost = require("@/assets/img/question/theory_post.jpg");
const practicalPost = require("@/assets/img/question/practical_post.jpg");

export default {
  name: "QuestionBankCard",
  props: {
    data: Object,
    questionBankType: Number
  },
  data() {
    return {
      theoryPost,
      practicalPost
    };
  },
  computed: {
    courseName() {
      // 题库接口直接返回 courseName，不再额外拉课程 my-list
      if (this.data && this.data.courseName) {
        return this.data.courseName;
      }
      return "";
    },
    coverImage() {
      return this.questionBankType == 2 ? this.practicalPost : this.theoryPost;
    },
    typeLabel() {
      return this.questionBankType == 2 ? "实操题库" : "理论题库";
    }
  },
  methods: {
    openQuestionBank() {
      this.$router.push({
        path: `${this.$route.path}/manage`,
        query: { id: this.data.questionBankId }
      });
    },
    addQuestion() {
      this.$emit("open", this.data.questionBankId);
    },
    async deleteInfo() {
      try {
        await this.$confirm("确定删除该题库吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        await deleteQuestionBank(this.data.questionBankId);
        this.$message.success("删除成功");
        this.$emit("success");
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
<style scoped lang="less">
.bank-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 18px rgba(15, 39, 73, 0.06);
  transition: transform 0.2s, box-shadow 0.2s;
  box-sizing: border-box;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 28px rgba(99, 102, 241, 0.12);
  }

  &__cover {
    position: relative;
    height: 160px;
    flex-shrink: 0;
    overflow: hidden;
    background: #eef4ff;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  &__type-tag {
    position: absolute;
    left: 12px;
    top: 12px;
    padding: 2px 10px;
    border-radius: 999px;
    font-size: 12px;
    color: #fff;
    background: rgba(28, 104, 255, 0.85);
    backdrop-filter: blur(4px);
  }

  &__body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 16px 18px;
    min-height: 0;
  }

  &__title {
    margin: 0 0 8px;
    font-size: 16px;
    font-weight: 700;
    color: #1e1b4b;
    line-height: 1.2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    word-break: break-word;
    min-height: 2.4em;
    cursor: default;
  }

  &__course {
    margin: 0 0 10px;
    font-size: 14px;
    color: #64748b;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__meta {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    color: #64748b;
    margin-bottom: 6px;
  }

  &__meta-dot {
    opacity: 0.5;
  }

  &__time {
    font-size: 12px;
    color: #64748b;
    margin-bottom: 14px;
  }

  &__footer {
    margin-top: auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/QuestionBank/QuestionBankCard.vue